import AlertSnackbar from "./AlertSnackbar";
import InfoSnack from "./InfoSnack";

export { AlertSnackbar, InfoSnack };



// WEBPACK FOOTER //
// ./src/components/Snackbar/index.js